module.exports = __webpack_public_path__ + "img/facebook.b867752d.jpg";